export const ADMINISTRATOR_TYPE = "ADMINISTRATOR";
export const EMPLOYEE_TYPE = "EMPLOYEE";
export const LOGGED_USER_STORAGE_KEY = "loggedUser";

export const ADMINISTRATOR_TYPE_LABELS = {
  [ADMINISTRATOR_TYPE]: "Administrator",
  [EMPLOYEE_TYPE]: "Zaposleni",
};

export const getStoredLoggedUser = () => {
  try {
    const storedUser = localStorage.getItem(LOGGED_USER_STORAGE_KEY);
    return storedUser ? JSON.parse(storedUser) : null;
  } catch (error) {
    return null;
  }
};

export const setStoredLoggedUser = (user) => {
  if (user) {
    localStorage.setItem(LOGGED_USER_STORAGE_KEY, JSON.stringify(user));
  } else {
    localStorage.removeItem(LOGGED_USER_STORAGE_KEY);
  }
};

export const isEmployee = (user) => user?.type === EMPLOYEE_TYPE;

export const canEmployeeAccessPath = (pathname) =>
  pathname === "/receipt-list" ||
  pathname.startsWith("/receipt-edit/");
